import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { mediaUrl } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Boxes, Search, Sparkles } from "lucide-react";

export default function PackagesBrowse() {
  const [packages, setPackages] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    api.get("/packages", { params }).then((r) => setPackages(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="packages-browse-page">
      <div className="flex items-center gap-2 text-primary"><Boxes className="w-5 h-5" /><span className="text-xs uppercase tracking-[0.2em] font-bold">Bundles & savings</span></div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tighter mt-1">Service packages</h1>
      <p className="text-muted-foreground mt-2">Pay once for a bundle of services from local providers, then schedule each at your convenience.</p>

      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="mt-8 flex gap-2 max-w-xl">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search packages…" className="pl-9 rounded-sm" data-testid="packages-search-input" />
        </div>
        <Button type="submit" className="rounded-sm" data-testid="packages-search-btn">Search</Button>
      </form>

      {loading ? (
        <p className="text-muted-foreground mt-12">Loading…</p>
      ) : packages.length === 0 ? (
        <p className="text-muted-foreground mt-12" data-testid="packages-browse-empty">No packages available yet. Check back soon.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {packages.map((p) => (
            <Link key={p.id} to={`/packages/${p.id}`} data-testid={`package-browse-${p.id}`}
              className="group bg-white border border-border rounded-sm p-6 hard-shadow-hover transition-all hover:-translate-y-[2px]">
              {p.cover_url && <img src={mediaUrl(p.cover_url)} alt={p.name} className="w-full h-36 object-cover rounded-sm mb-4 -mt-1" />}
              <div className="flex items-center justify-between">
                <h3 className="font-display text-xl font-medium">{p.name}</h3>
                {p.total_savings > 0 && <span className="text-xs font-bold text-primary bg-primary/10 rounded-sm px-2 py-0.5 flex items-center gap-1"><Sparkles className="w-3 h-3" />Save ${p.total_savings}</span>}
              </div>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{p.description || "—"}</p>
              <div className="mt-4 space-y-1 border-t border-border pt-3">
                {p.items.map((i) => (
                  <div key={i.service_id} className="flex justify-between text-sm">
                    <span className="text-foreground/80">{i.service_title} <span className="text-xs text-muted-foreground">· {i.provider_name}</span></span>
                  </div>
                ))}
              </div>
              <div className="flex items-center justify-between mt-4 pt-3 border-t border-border">
                <span className="text-sm text-muted-foreground">{p.items.length} services</span>
                <span className="font-display text-lg font-semibold text-primary">${p.total_price} <span className="text-xs text-muted-foreground line-through">${p.total_base}</span></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
